import { useTheme, alpha } from '@mui/material/styles';
import PropTypes from 'prop-types';

const TemplateHero = ({
  backgroundImage,
  backgroundColor,
  backgroundOpacity = 1, // Default to fully opaque
  afterBackgroundImage,
  afterBackgroundColor,
  afterBackgroundColorOpacity = 1,
  textColor,
  children,
  ...rest
}) => {
  const theme = useTheme();

  // Direct mapping from provided theme:
  const paletteMapping = {
    primary: theme.palette.primary.main, // PRIMARY
    secondary: theme.palette.secondary.main, // SECONDARY
    textPrimary: theme.palette.text.primary, // TEXT
    textSecondary: theme.palette.text.secondary, // LIGHT TEXT
    complementary: theme.palette.background.paper, // COMPLEMENTARY
  };

  const heroBackgroundColor = paletteMapping[backgroundColor] ?? backgroundColor ?? '#ffffff00';
  const heroTextColor = paletteMapping[textColor] ?? textColor ?? theme.palette.text.primary;
  const afterBgColor = paletteMapping[afterBackgroundColor] ?? afterBackgroundColor ?? 'transparent';

  return (
    <div
      {...rest}
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
        backgroundColor: alpha(heroBackgroundColor, backgroundOpacity), // Apply opacity here
        backgroundSize: 'cover',
        backgroundPosition: 'center top !important',
        position: 'relative',
        color: heroTextColor,
      }}
    >
      {children}
      <div
        style={{
          content: '""',
          backgroundImage: afterBackgroundImage ? `url(${afterBackgroundImage})` : undefined,
          backgroundColor: afterBgColor,
          opacity: afterBackgroundColorOpacity,
          backgroundSize: 'cover',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          paddingTop: '100px'
        }}
      />
    </div>
  );
};

TemplateHero.propTypes = {
  backgroundImage: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundOpacity: PropTypes.number,
  afterBackgroundImage: PropTypes.string,
  afterBackgroundColor: PropTypes.string,
  afterBackgroundColorOpacity: PropTypes.string,
  textColor: PropTypes.string,
  children: PropTypes.node,
};

export default TemplateHero;
